// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type ProposalScenarioFragment = { __typename?: 'ProposalScenario', id: string, gratProposalScenario?: { __typename?: 'GRATProposalScenario', id: string, createdAt: Time, updatedAt: Time, projectedAnnualReturnThroughTerm?: Percent | null, projectedAnnualReturnAfterTerm?: Percent | null, projectionTimePeriodYears: number, projectedMarketValueAtTerm?: CurrencyUSD | null, inTermValuationType?: Types.GratProposalScenarioInTermValuationType | null, inTermCAGRV2: Percent } | null };

export const Operations = {
  Fragment: {
    ProposalScenario: 'ProposalScenario' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ProposalScenarioFragmentDoc = gql`
    fragment ProposalScenario on ProposalScenario {
  id
  gratProposalScenario {
    id
    createdAt
    updatedAt
    projectedAnnualReturnThroughTerm
    projectedAnnualReturnAfterTerm
    projectionTimePeriodYears
    projectedMarketValueAtTerm
    inTermValuationType
    inTermCAGRV2
  }
}
    `;